import { AavoGridColDef } from "src/components/common/dataGrid/types";
import {
	dateColumn,
	dateTimeColumn,
	enumColumn,
	moneyColumn,
	textColumn,
} from "src/components/common/dataGrid/columns.tsx";
import i18n from "i18next";
import { SalesCommissionLineView } from "src/api/generated/erp/db/types/tables/salesCommissionLineView.ts";
import { getSalesCommissionLineStateLabels } from "src/api/generated/io/aavo/applications/db/erp/types/salesCommissionLineState.ts";
import {
	getCustomerOrderTenantStateLabel,
	renderMoneyCellWithRowCurrency,
} from "src/components/views/erp/sales/salesUtils.ts";
import { TenantConfig } from "src/tenantCustomizations/TenantCustomizations.ts";

export const getSalesCommissionLinesDataGridColumns = ({
	tenantConfig,
	showSalesperson = true,
	showState = true,
	showEstimatedApprovalDate = true,
	showApprovalColumns = true,
	showPaymentColumns = true,
	showCustomerOrderColumns = true,
}: {
	tenantConfig: TenantConfig;
	showSalesperson?: boolean;
	showState?: boolean;
	showEstimatedApprovalDate?: boolean;
	showApprovalColumns?: boolean;
	showPaymentColumns?: boolean;
	showCustomerOrderColumns?: boolean;
}): AavoGridColDef<SalesCommissionLineView>[] => [
	showSalesperson &&
		textColumn({
			field: "salespersonName",
			headerName: i18n.t("salesperson"),
			width: 150,
			mobile: "cell",
		}),
	showCustomerOrderColumns && [
		textColumn({
			field: "customerOrderId",
			headerName: i18n.t("customer_order"),
		}),
		textColumn({
			field: "orderReference",
			headerName: i18n.t("order_reference"),
			width: 120,
			mobile: "cell",
		}),
		tenantConfig.erp.useCustomerOrderTenantStates &&
			textColumn({
				field: "customerOrderTenantState",
				headerName: tenantConfig.erp.customerOrderTenantStateColumnLabel,
				valueGetter: (_, row) => getCustomerOrderTenantStateLabel(row.customerOrderTenantState, tenantConfig),
			}),
	],
	textColumn({
		field: "name",
		headerName: i18n.t("name"),
		width: 150,
		mobile: "header",
	}),
	moneyColumn({
		field: "sum",
		headerName: i18n.t("sum"),
		mobile: "cell",
		renderCell: renderMoneyCellWithRowCurrency((row) => row.currencyCode),
	}),
	textColumn({
		field: "note",
		headerName: i18n.t("note"),
		width: 150,
		mobile: "cell",
	}),
	dateTimeColumn({
		field: "createdAt",
		headerName: i18n.t("created_at"),
		width: 150,
	}),
	showEstimatedApprovalDate &&
		dateColumn({
			field: "estimatedApprovalDate",
			headerName: i18n.t("estimated_approval"),
			width: 150,
		}),
	showState &&
		enumColumn({
			field: "salesCommissionLineState",
			headerName: i18n.t("state"),
			enumLabels: getSalesCommissionLineStateLabels(),
			width: 150,
			mobile: "cell",
		}),
	showApprovalColumns && [
		dateTimeColumn({
			field: "approvedAt",
			headerName: i18n.t("approved_at"),
			width: 140,
		}),
		textColumn({
			field: "approvedByUserName",
			headerName: i18n.t("approved_by"),
			width: 120,
		}),
	],
	showPaymentColumns && [
		dateTimeColumn({
			field: "paymentApprovedAt",
			headerName: i18n.t("payment_approved_at"),
			width: 150,
		}),
		textColumn({
			field: "paymentApprovedByUserName",
			headerName: i18n.t("payment_approved_by"),
			width: 160,
		}),
	],
];
